import { useState } from "react";
export function analysisChartWindow<T>(rows: readonly T[], size: number, requested: number) {
  const pages = Math.max(1, Math.ceil(rows.length / size));
  const page = Math.max(0, Math.min(requested, pages - 1));
  return { rows: rows.slice(page * size, (page + 1) * size), page, pages };
}
export function useAnalysisChartPage<T>(rows: readonly T[], size: number, scope: string) {
  const [selection, setSelection] = useState({ scope, page: 0 });
  const window = analysisChartWindow(rows, size, selection.scope === scope ? selection.page : 0);
  return { ...window, onPage: (next: number) => setSelection({ scope, page: next }) };
}
export function AnalysisChartPagination({ page, pages, onPage }: { page: number; pages: number; onPage: (page: number) => void }) {
  return pages > 1 ? <nav className="pa-chart-pagination" aria-label="Grafik sayfaları"><button type="button" disabled={page === 0} onClick={() => onPage(page - 1)}>Önceki</button><span aria-live="polite">{page + 1} / {pages}</span><button type="button" disabled={page === pages - 1} onClick={() => onPage(page + 1)}>Sonraki</button></nav> : null;
}
